import React from 'react';
import { ICONS } from '../../../constants/icons';
import makeIconName from '../../../utils/makeIconName';
import makeBodyText from '../../../utils/makeText';
import styles from './index.module.scss';
const Item = ({ item }) => {
    return (React.createElement("div", { className: styles.itemWrap },
        React.createElement("div", { className: styles.leftSection },
            React.createElement("i", { className: `${makeIconName(ICONS.x32.quote, 'x32')} ${styles.icon}` })),
        React.createElement("div", { className: styles.rightSection },
            React.createElement("div", { className: styles.textData },
                React.createElement("p", { className: `${makeBodyText('XL')} ${styles.text}` }, item.testimonial),
                React.createElement("span", { className: `${makeBodyText('XL')} ${styles.text}` },
                    React.createElement("strong", null, item.author))))));
};
export default Item;
